import { FormTitle, NavigationButtons } from '@molecules/TextArea/TextArea';
import { useNavigate } from 'react-router-dom';
import { RoutesList } from '../routes/Routes';
import { scrollTop } from '@utils';

export const ReportToTflPage = () => {
  const navigate = useNavigate();
  const formTitle = 'You cannot report road damage from this location';

  const buttonNext = {
    label: 'Report to Transport for London (TfL)',
    isExternalLink: true,
    href: 'https://tfl.gov.uk/help-and-contact/contact-us-about-streets-and-other-road-issues',
  };

  const buttonPrevious = {
    label: 'Previous',
    onClick: () => {
      navigate(RoutesList.ISSUE_LOCATION);
      scrollTop();
    },
  };

  return (
    <>
      <FormTitle text={formTitle} />

      <div className="text-bodyLg my-4 flex flex-col gap-4">
        <p className="font-semibold">Who to report to instead</p>
        <p>
          Report this issue to{' '}
          <a
            href="https://tfl.gov.uk/help-and-contact/contact-us-about-streets-and-other-road-issues"
            className="text-action-link underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            Transport for London (TfL).
          </a>
        </p>
        <p>TfL will handle this report and take any necessary action.</p>
        <p className="font-semibold">
          Why report to Transport for London (TfL)?
        </p>
        <p>
          TfL maintains this road. If you tell them about the problem, they’ll
          look into it. 
        </p>
      </div>

      <NavigationButtons
        buttonNext={buttonNext}
        buttonPrevious={buttonPrevious}
      />
    </>
  );
};
